// extracted by mini-css-extract-plugin
export default {"heading":"AdPlacement_heading__3Nkra","wrapper":"AdPlacement_wrapper__2-fV-"};